export default {
  pcrejectbutton: {
    root: {
      class: [
        'relative',

        // Alignments
        'items-center inline-flex text-center align-bottom justify-center',

        // Sizes & Spacing
        'px-4 py-3 leading-none',

        // Shape
        'rounded-md',

        // Color
        'text-surface-900 dark:text-white',
        'bg-surface-100 dark:bg-surface-700',
        'border border-surface-100 dark:border-surface-700',

        // States
        'hover:bg-surface-300/20'
      ]
    }
  },
  pcacceptbutton: {
    root: {
      class: [
        'relative',

        // Alignments
        'items-center inline-flex text-center align-bottom justify-center',

        // Sizes & Spacing
        'px-4 py-3 leading-none',

        // Shape
        'rounded-md',

        // Color
        'text-white dark:text-white',
        'bg-primary-500 dark:bg-primary-400',
        'border border-primary-500 dark:border-primary-400',

        // States
        'hover:bg-primary-600 dark:hover:bg-primary-300 hover:border-primary-600 dark:hover:border-primary-300'
      ]
    }
  },
  content: {
    class: 'p-5 items-center flex'
  },
  icon: 'w-8 h-8 text-[2rem] mr-2'
}
